import type { FallbackProps } from 'react-error-boundary';

import ErrorTemplate from './error-template';

/**
 * Fallback для react-error-boundary: показывает «что-то пошло не так».
 * Сброс границы завязан на смену маршрута (resetKeys в app.provider) — переход на главную
 * по кнопке снимает ошибку сам, поэтому resetErrorBoundary здесь не требуется.
 */
const ErrorFallback: React.FC<FallbackProps> = () => (
  <ErrorTemplate type="oops" />
);

export default ErrorFallback;
